<template>
    <div id="login">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="login-content d-flex row">
                        <div class="col-md-6 pr-0 order-1 order-md-0">
                            <div
                                class="login-banner d-flex"
                                :style="{ backgroundImage: 'url(' + require('@/assets/images/banner-login.png') + ')' }"
                            >
                                <div class="align-self-center">
                                    Wadah resmi alumni FBE UBAYA untuk membangun jejaring profesional,
                                    kolaborasi lintas generasi, dan kontribusi nyata bagi almamater
                                    serta masyarakat.
                                </div>
                            </div>
                        </div>

                        <div class="login-form col-md-6 order-0 order-md-1">
                            <h3>Daftar</h3>
                            <p>Silahkan masukkan data yang sesuai</p>
                            <br><br>

                            <transition name="fade" mode="out-in">
                                <form @submit.prevent="actionRegister">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <input
                                                type="text"
                                                v-model="firstname"
                                                @input="checkForInput"
                                                class="form-control"
                                                placeholder="Nama Depan"
                                            >
                                        </div>
                                        <div class="col-md-6">
                                            <input
                                                type="text"
                                                v-model="lastname"
                                                @input="checkForInput"
                                                class="form-control"
                                                placeholder="Nama Belakang"
                                            >
                                        </div>
                                    </div>

                                    <input
                                        type="text"
                                        v-model="username"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Username"
                                    >

                                    <input
                                        type="email"
                                        v-model="email"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Email"
                                    >

                                    <input
                                        type="text"
                                        v-model="generation"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Angkatan"
                                    >

                                    <input
                                        type="text"
                                        v-model="no_induk"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="NRP"
                                    >

                                    <input
                                        type="text"
                                        v-model="domisili"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Domisili"
                                    >

                                    <input
                                        type="text"
                                        v-model="phone"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Nomor HP"
                                    >

                                    <input
                                        type="text"
                                        v-model="pekerjaan"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Pekerjaan / Usaha saat ini"
                                    >

                                    <input
                                        type="password"
                                        v-model="password"
                                        @input="checkForInput"
                                        class="form-control"
                                        placeholder="Kata Sandi"
                                    >

                                    <vue-recaptcha
                                        sitekey="6Lf801IsAAAAAHktDKGkcCBF8ZFIxg82RhOdTtYs"
                                        @verify="onVerify"
                                    />

                                    <br>

                                    <b-form-checkbox
                                        value="1"
                                        unchecked-value=""
                                        v-model="terms"
                                        @change="checkForInput"
                                    >
                                        Saya menyetujui
                                        <a href="/terms-condition" target="_blank">Syarat dan Ketentuan</a>
                                        dan
                                        <a href="/privacy-policy" target="_blank">Kebijakan Privasi</a>
                                    </b-form-checkbox>

                                    <br>

                                    <button
                                        class="btn btn-primary fullsize-btn"
                                        :class="disabled"
                                        :disabled="disabled === 'disabled'"
                                    >
                                        Daftar
                                    </button>
                                </form>
                            </transition>

                            <br><br>
                            <center>
                                Sudah punya akun?
                                <router-link to="/login"><b>Masuk</b></router-link>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Icon } from '@iconify/vue2'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
    name: 'Register',
    components: {
        Icon,
        VueRecaptcha
    },
    data () {
        return {
            username: '',
            password: '',
            firstname: '',
            lastname: '',
            email: '',
            generation: '',
            no_induk: '',
            phone: '',
            pekerjaan: '',
            domisili: '',
            terms: '',
            captcha: false,
            disabled: 'disabled'
        }
    },
    methods: {
        async actionRegister () {
            try {
                const response = await axios.post('register', {
                    username: this.username,
                    password: this.password,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    generation: this.generation,
                    no_induk: this.no_induk,
                    type: 'alumni',
                    phone: this.phone,
                    pekerjaan: this.pekerjaan,
                    domisili: this.domisili
                })

                if (response.data.status) {
                    this.$swal({
                        icon: 'success',
                        title: 'Registrasi Berhasil',
                        text: response.data.message ||
                              'Akun Anda berhasil dibuat dan sedang menunggu persetujuan admin.',
                        confirmButtonText: 'OK'
                    }).then(() => {
                        this.$router.push('/login')
                    })
                } else {
                    this.$swal({
                        icon: 'error',
                        title: 'Registrasi Gagal',
                        text: response.data.message || 'Terjadi kesalahan'
                    })
                }

            } catch (error) {
                this.$swal({
                    icon: 'error',
                    title: 'Registrasi Gagal',
                    text: error.response?.data?.message || 'Terjadi kesalahan server'
                })
            }
        },

        checkForInput () {
            if (
                this.captcha &&
                this.terms !== '' &&
                this.username !== '' &&
                this.password !== '' &&
                this.email !== '' &&
                this.firstname !== ''
            ) {
                this.disabled = ''
            } else {
                this.disabled = 'disabled'
            }
        },

        onVerify () {
            this.captcha = true
            this.checkForInput()
        }
    }
}
</script>
